// extracted by mini-css-extract-plugin
export default {"advertCardPhoto":"c-a_jk","advertCardPhoto__image":"c-a_jl"};